export default __webpack_public_path__ + "static/media/back_icon.52647d5d.svg";